import { render, staticRenderFns } from "./resolution-14.vue?vue&type=template&id=1cdf06fc&scoped=true"
import script from "./resolution-14.vue?vue&type=script&lang=js"
export * from "./resolution-14.vue?vue&type=script&lang=js"
import style0 from "./resolution-14.vue?vue&type=style&index=0&id=1cdf06fc&prod&lang=sass&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1cdf06fc",
  null
  
)

export default component.exports